// src/prefetch.js — fetches critiques lancés dès le parse du bundle, en
// parallèle de la vérification de session (/api/me). Sans ça, le splash
// attend bundle → /api/me → mount de App → data en série.
// Si la session n'est pas encore établie (401), le fetch résout null et le
// mount de App repasse par le chemin normal (apiFetchCached).
const IS_SCAN_ROUTE = typeof window !== 'undefined' &&
  window.location.pathname.replace(/\/+$/, '').toLowerCase() === '/scan';

const start = (url) => fetch(`${url}?v=${Date.now()}`, {
  cache:       'no-store',
  credentials: 'same-origin',
  headers:     { 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Pragma': 'no-cache' },
}).then(r => (r.ok ? r.json() : null)).catch(() => null);

const store = IS_SCAN_ROUTE ? {} : {
  '/api/supabase-data': start('/api/supabase-data'),
  '/api/square-data':   start('/api/square-data'),
};

// Consommé une seule fois (premier mount de App) — les refetchs suivants
// repassent par apiFetchCached.
export function consumePrefetch(url) {
  const p = store[url] || null;
  delete store[url];
  return p;
}
